import {
  Component, Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import {
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective,
  LgIconComponent
} from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { LinkComponent } from "../Link/Link.component";
import { DynamicComponentItem } from "../../utils/dynamic-loader/dynamic-component-item";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { HtmlTagService } from "../../../services/html-tag/html-tag.service";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "dotcom-frontend-footer",
  templateUrl: "./Footer.component.html",
  styleUrl: "./Footer.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    LgIconComponent,
    LinkComponent,
    LoaderComponent
  ]
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() data: CmsData | undefined;
  footerData: any | undefined;
  logoUrl: string | undefined;
  logoImage: string | undefined;
  logoAltText: string | undefined;
  copyrightText: string | undefined;
  primaryLinks: any | undefined;
  footerDisclaimerComponent: DynamicComponentItem | undefined;
  displayLogo: boolean | undefined;
  pageTitle = "";
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  socialLinks: any = [];
  icon: any;
  oneTrustScript: any | undefined;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private store: Store<{ global: GlobalState }>,
    private analyticsService: AnalyticsService,
    private htmlTagService: HtmlTagService
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  ngOnInit() {
    if (this.data) {
      this.footerData = this.data["footerData"];
      this.logoUrl = this.data["logoUrl"];
      this.logoImage = this.data["logoImage"];
      this.logoAltText = this.data["logoAltText"];
      this.socialLinks = this.data["footerData"]["socialLinks"];
      this.oneTrustScript = this.data["oneTrustScript"];
    }

    if (this.footerData) {
      this.copyrightText = this.footerData["footerCopyrightText"];
      this.primaryLinks = this.footerData["primaryLinks"];
      this.footerDisclaimerComponent = this.footerData["disclaimerComponent"];

      if (this.footerData["displayLogo"]) {
        this.displayLogo = this.footerData["displayLogo"];
      }
    }

    if (this.oneTrustScript) {
      this.addOneTrustScript();
    }
  }

  interactionClickEvent(clickUrl: any, clickName: any) {
    this.analyticsService.adobeInteractionEvent(
      "Footer Block",
      clickUrl,
      clickName,
      "",
      "LinkClick",
      this.pageTitle,
      ""
    );
  }

  addOneTrustScript() {
    if (this.oneTrustScript?.scriptUrl) {
      const oneTrustDomain = new URL(this.oneTrustScript.scriptUrl).origin;
      this.htmlTagService.addTag({
        tag: "link",
        identifier: "js-one-trust-preconnect",
        rel: "preconnect",
        href: oneTrustDomain
      });

      this.htmlTagService.addTag({
        tag: "script",
        identifier: "js-one-trust-script",
        type: "text/javascript",
        src: this.oneTrustScript.scriptUrl,
        async: "true",
        charset: "UTF-8",
        data: {
          "domain-script": this.oneTrustScript.scriptId
        }
      });
    }
  }

  openCookiePreferences() {
    if ((window as any)?.OneTrust) {
      (window as any).OneTrust.ToggleInfoDisplay();
    }
  }

  ngOnDestroy() {
    if (this.oneTrustScript) {
      const banner = this.document.getElementById("onetrust-pc-sdk");

      this.htmlTagService.addTag({
        identifier: `js-one-trust-script`,
        mode: "remove"
      });

      if (banner) {
        banner.remove();
      }
    }
  }
}
